import React, { useEffect, useContext } from 'react';
import './style.css';
import { WindowSizeContext, AddressSearchContext } from '/src/App';
import UnderConstruction from '/src/Components/UnderConstruction/UnderConstruction';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import PlatformGoals from '/src/Components/PlatformGoals/PlatformGoals';
import GetPlatformGoals from '/src/services/Content/GetPlatformGoals';
import { MoveDown, CircleArrowRight, ArrowRight } from 'lucide-react';
import ImageCarousel from '/src/Components/ImageCarousel/ImageCarousel';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';
import AddressSearch from '/src/Components/AddressSearch/AddressSearch';
import StandardButton from '/src/Components/StandardButton/StandardButton';

const WhatIsQuoll = () => {
    const { deviceType } = useContext(WindowSizeContext);

    // Update the page title to "What is Quoll?"
    // useEffect(() => {
    //     document.title = "What is Quoll?";
    // }, []);

    // const imageFilename = "quoll-hero-image.png";
    const imageFilename = "quoll-product-general-sample.webp";
    const imageUrl = CreateCloudfrontUrl(imageFilename);

    const ourMissionImageFilename = "quoll-our-mission-illustration.webp";
    const ourMissionImageUrl = CreateCloudfrontUrl(ourMissionImageFilename);
    const ourMissionImageAlt = "Quoll - Our Mission";

    // const title = "We Translate Climate Risk into Intelligence You Can Act On";
    const title = "Protect Your Home — No Climate Expertise Needed";
    // const introText = "Quoll is a free platform that provides a comprehensive analysis of your home's climate risk profile and targeted home improvement recommendations to increase the property's resilience, protect your wallet, and unlock meaningful financial benefits. "
    const introText = "Being a homeowner is challenging enough. Rising insurance bills, unexpected storm damage, and confusing climate risks only add to the pressure.<br/><br/>Quoll simplifies it all. Our free home climate analysis shows you what risks matter most at your address, how they could affect your costs and value, and what steps you can take to protect your home and wallet."

    const subtitle = "What You'll See When You Search Your Home"
    const section2Text = "Wondering how much climate risk might cost you—or what upgrades can protect your house from extreme weather?<br/><br/>When you search your address, Quoll breaks it down: climate threats, financial impacts, and specific projects to lower your risks and costs. Our tool helps you plan ahead for insurance changes, rising utility bills, and unexpected repairs before they happen."


    const extendedPlatformGoals = GetPlatformGoals('extended');
    const first3Goals = extendedPlatformGoals.slice(0, 3);

    const readyToSeeForYourselfHeader = "Ready to See It for Yourself?";
    const readyToSeeForYourselfText = "Understanding your home’s climate risks and financial exposure takes just seconds. Enter your address to explore your free, personalized home analysis and start building resilience today."

    const internalLinks = [
        {
            text: "See how our analysis works",
            link: "/about/methodology"
        },
        {
            text: "Find answers to common questions",
            link: "/about/faq"
        },
        {
            text: "Learn why the tool is free and independent",
            link: "/about/why-is-quoll-free"
        },
        {
            text: "Browse homeowner guides and insights",
            link: "/resources"
        }
    ]

    const whatIsQuollHeader = "What is Quoll?";
    const whatIsQuollText = "Quoll is a web platform designed to help current and prospective homeowners understand the unique climate risk profile of their home while providing guidance and tools to let them take action to protect their home and wallet. We leverage big data modeling and AI to process millions of datapoints on a given home and its surroundings to ensure that every homeowner is empowered with the information they need and the ability to act. "

    const aboutUsHeader = "Our Mission";
    const aboutUsText = "Quoll is a web platform designed to help current and prospective homeowners understand the unique climate risk profile of their home while providing guidance and tools to let them take action to protect their home and wallet. We leverage big data modeling and AI to process millions of datapoints on a given home and its surroundings to ensure that every homeowner is empowered with the information they need and the ability to act. "

    const quollBlobFilename = "quoll-blob-4.svg"
    const quollBlobUrl = CreateCloudfrontUrl(quollBlobFilename);

    const whatIsQuollIllustrationFilename = "quoll-what-is-quoll-illustration-v3.webp"
    const whatIsQuollIllustrationUrl = CreateCloudfrontUrl(whatIsQuollIllustrationFilename);


    const quollLogoFilename = "quoll-logo-business-green-animal-only.png"
    const quollLogoUrl = CreateCloudfrontUrl(quollLogoFilename);

    const whoWeAreText1 = "At Quoll, we believe every homeowner and homebuyer deserves clear, honest information about their home. Our mission is to help you understand how climate risks and everyday costs connect—and what they mean for your long-term financial stability."
    const whoWeAreText2 = "We're built on a simple idea: the right information empowers better decisions. With approachable guidance and grounded data, we help you protect your home, your finances, and your family's peace of mind."

    const connectWithUsOptions = [
        {
            text: "Get In Touch",
            options: [
                {
                    text: "Contact Us",
                    link: "/contact-us"
                },
                {
                    text: "Work With Us",
                    link: "/careers"
                }
            ]
        },
        // {
        //     text: "Follow Us",
        //     options: [
        //         {
        //             icon: "facebook-logo.webp",
        //             link: "https://www.facebook.com/quollintelligence"
        //         },
        //         {
        //             icon: "instagram-logo.webp",
        //             link: "https://www.instagram.com/quollintelligence"
        //         },
        //         {
        //             icon: "twitter-logo.png",
        //             link: "https://www.twitter.com/quollintelligence"
        //         }
        //     ]
        // }
    ]


    return (
        <>
            <HelmetProvider
                pageType="whatIsQuoll"
            />
            <div className="static-page-content-frame">
                {/* <UnderConstruction /> */}
                <div className="what-is-quoll-section-container">
                    <div className="what-is-quoll-header-container">
                        <div className={`what-is-quoll-image-container ${deviceType}`}>
                            <img src={whatIsQuollIllustrationUrl} alt="What is Quoll Illustration" />
                            <div className="what-is-quoll-logo-container">
                                <img src={quollLogoUrl} alt="Quoll Logo" />
                            </div>
                        </div>
                        <h1>{whatIsQuollHeader}</h1>
                    </div>
                    <p className="what-is-quoll-intro-text text-align-center" dangerouslySetInnerHTML={{ __html: whatIsQuollText }} />

                </div>
                <div className="horizontal-divider" />

                <div className="what-is-quoll-section-container">
                    <h2>{aboutUsHeader}</h2>
                    <div className={`what-is-quoll-about-us-container ${deviceType}`}>
                        <div className="what-is-quoll-about-us-image-container">
                            <img src={ourMissionImageUrl} alt={ourMissionImageAlt} />
                        </div>
                        <div className="what-is-quoll-about-us-text-container">

                            <p className="what-is-quoll-intro-text text-align-center" dangerouslySetInnerHTML={{ __html: whoWeAreText1 }} />
                            <p className="what-is-quoll-intro-text text-align-center" dangerouslySetInnerHTML={{ __html: whoWeAreText2 }} />
                        </div>
                    </div>
                    <div className="what-is-quoll-connect-with-us-container">
                        {connectWithUsOptions.map((option, idx) => {
                            return (
                                <div className="what-is-quoll-connect-with-us-option" key={idx}>
                                    {/* <h3 className="what-is-quoll-connect-with-us-option-header">{option.text}</h3> */}
                                    <div className={`what-is-quoll-connect-with-us-sub-options-container ${deviceType}`}>
                                        {option.options.map((subOption, subIdx) => {
                                            return (
                                                <StandardButton
                                                    text={subOption.text}
                                                    link={subOption.link}
                                                    id={`what-is-quoll-connect-with-us-sub-option-${idx}-${subIdx}`}
                                                    key={`what-is-quoll-connect-with-us-sub-option-${idx}-${subIdx}`}
                                                />
                                                //     <>
                                                //         {subOption.icon && <img src={CreateCloudfrontUrl(subOption.icon)} alt={subOption.text} />}
                                                //         {subOption.text && <button
                                                //             className="hero-button hero-button-primary"
                                                //         >
                                                //             {subOption.text}
                                                //         </button>}
                                                //     </>
                                                // </a>
                                            )
                                        })}
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                </div>
            </div>
        </>
    );
};

export default WhatIsQuoll;